<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Existen campos vacios que son
                obligatorios!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Tarifa</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Clase</label
                    >
                    <argon-input
                      v-model="rate.kind"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="0"
                      name="Clase"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Descripción</label
                    >
                    <argon-input
                      v-model="rate.description"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="1"
                      name="Descripción"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Tarifa</label
                    >
                    <argon-input
                      v-model="rate.price"
                      @valid="absoluteValidation($event)"
                      type="number"
                      :isRequired="true"
                      id="2"
                      name="Tarifa"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "rate-card",
  props: {
    rateID: { type: String, required: true },
    bypassID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      rateIDLocal: this.rateID,
      rate: {
        kind: "",
        bypass_id: parseInt(this.bypassID),
        description: "",
        price: "",
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert },
  created() {
    // console.log("RATE RATE RATE");
    // console.log(this.rateIDLocal);
    // console.log(this.bypassID);
    if (this.bypassID !== "0") {
      if (this.rateIDLocal !== "0") {
        this.plain
          .get(`/rates/${this.rateIDLocal}`)
          .then((response) => {
            delete response.data.id;
            delete response.data.created_at;
            delete response.data.updated_at;
            this.rate = response.data;
            this.isLoading = false;
            // console.log("RESPONSE");
            // console.log(this.rate);
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
          });
      } else {
        this.rateIDLocal = undefined;
        this.isLoading = false;
      }
    } else {
        //this.$router.go('/')
        //VALIDACION DE RUTA ERRONEA AL NO EXISTIR EL ID DEL LIBRAMIENTO
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.rateIDLocal !== undefined) this.editRate();
        else this.createRate();
      }
    },
    createRate() {
        // console.log('CREANDO RATE');
        // console.log(this.rate);
      this.plain
        .post("/rates", this.rate)
        .then((response) => {
          // console.log("TARIFA creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.rateIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.rate = response.data;
        })
        .catch((error) => {
          console.log("Error al crear TARIFAS", error);
        });
    },
    editRate() {
      this.plain
        .patch(`/rates/${this.rateIDLocal}`, this.rate)
        .then((response) => {
          // console.log("TARIFA editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          //this.rateID = response.data.id;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.rate = response.data;
          // console.log("EDIT");
          // console.log(this.rate);
        })
        .catch((error) => {
          console.log("Error al editar TARIFAS", error);
        });
    }
  },
};
</script>